export default function BlockButton({ caption, icon, url, bgClass, textClass }) {
    const className = "d-flex justify-content-center align-items-center h-30 text-decoration-none border-transparent rounded " + bgClass + " " + textClass;
    return (
        <a href={url} target="_blank" className={className}>
            {icon}
            {caption}
        </a>
    )
}